module.exports = "/_next/static/images/PropCardCta-12d31cafd6945db4b3931cc71f55a293.webp";